const parseSearch = (search) => {
  const params = new URLSearchParams(search)

  return {
    eventId: params.get('eventId') || undefined,
    occurredAt: params.get('occurredAt') || undefined,
    previousPath: params.get('previousPath') || undefined,
  }
}

export default parseSearch
